import React from 'react';

export default function TemplateDiffModal({ open, onClose, diff }) {
  if (!open) return null;
  const changed = Array.isArray(diff?.changedFields) ? diff.changedFields : [];

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl rounded-2xl bg-white dark:bg-[#151f2b] border border-slate-200 dark:border-slate-800 p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold text-slate-900 dark:text-white">Şablon Farkı</h3>
          <button onClick={onClose} className="text-sm font-bold text-slate-500">Kapat</button>
        </div>
        <div className="text-sm text-slate-600 dark:text-slate-300">
          <p>Değişen alanlar: {changed.join(', ') || '-'}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
          <div>
            <p className="mb-1 text-xs font-bold text-slate-500">Hedef Sürüm</p>
            <pre className="rounded-xl bg-slate-50 dark:bg-slate-900 p-3 text-xs overflow-auto">{JSON.stringify(diff?.target || {}, null, 2)}</pre>
          </div>
          <div>
            <p className="mb-1 text-xs font-bold text-slate-500">Mevcut Sürüm</p>
            <pre className="rounded-xl bg-slate-50 dark:bg-slate-900 p-3 text-xs overflow-auto">{JSON.stringify(diff?.current || {}, null, 2)}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}
